const dias = [
  { value: 'Seg', label: 'Segunda-feira', jsDay: 1 },
  { value: 'Ter', label: 'Terça-feira', jsDay: 2 },
  { value: 'Qua', label: 'Quarta-feira', jsDay: 3 },
  { value: 'Qui', label: 'Quinta-feira', jsDay: 4 },
  { value: 'Sex', label: 'Sexta-feira', jsDay: 5 },
  { value: 'Sab', label: 'Sábado', jsDay: 6 },
  { value: 'Dom', label: 'Domingo', jsDay: 0 },
];

export const diasDaSemanaOrdenadas = dias;

export const diasDaSemana = dias.map((item) => ({
  label: item.label,
  value: { value: item.value, label: item.label },
}));
